import {
  SoftwareManagementApplicationDetailsPageQueryDocument,
  SoftwareManagementUpdateSoftwarePaymentDocument,
  SoftwareManagementUpdateSoftwarePaymentMutation,
  SoftwareManagementUpdateSoftwarePaymentMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateSoftwarePayment = () => {
  const [updateSoftwarePayment, { loading }] = useMutation(
    SoftwareManagementUpdateSoftwarePaymentDocument,
    {
      extractorFn: (data: SoftwareManagementUpdateSoftwarePaymentMutation) =>
        data.softwareManagementMutations.updateSoftwaremanagementSoftwarePayment,
    }
  )

  return {
    update(
      variables: SoftwareManagementUpdateSoftwarePaymentMutationVariables,
      currency: string,
      companyId: number,
      softwareSetupId: number
    ) {
      return updateSoftwarePayment({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: SoftwareManagementApplicationDetailsPageQueryDocument,
            variables: {
              currency,
              companyId: companyId,
              softwareSetupId: softwareSetupId,
            },
          },
        ],
      })
    },
    loading,
  }
}
